export enum CollectiveInvoiceIssueTerm {
  LAST_DAY_OF_MONTH = 'last-day-of-month',
  FIRST_DAY_OF_MONTH = 'first-day-of-month',
  SELECTED_DAY = 'selected-day',
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
  SUNDAY = 'sunday',
}
